<template>
  <div class="my-3">
    <custom-callout
      class="custom-callout"
      controlled
      :opened="isOpen"
      :border-color="item.status.color"
      @click:open="onToggle()"
    >
      <div class="p-3 rounded bg-secondary-3">
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="color-secondary-6 font-14">
              Equipo:
            </div>
            <div class="font-weight-bold">
              {{ item.equipment?.name | empty }}
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="color-secondary-6 font-14">
              Tipo de Servicio:
            </div>
            <div class="font-weight-bold">
              {{ item.serviceType?.name | empty }}
            </div>
          </div>
          <div class="col-12 col-md">
            <div class="color-secondary-6 font-14">
              Estatus:
            </div>
            <div class="font-weight-bold">
              <custom-balloon
                :background-color="item.status.color"
                :text="item.status.name"
                dot
              />
            </div>
          </div>
          <div class="col-12 col-md" v-if="showActionItems">
            <drop-down
              :items="actionItems"
              always-show-dropdown
              class="float-md-right mr-5"
            />
          </div>
        </div>
        <div class="col-12 border-bottom mt-3"></div>
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="my-3 pt-2">
              <div class="color-secondary-6 font-14">
                Procede:
              </div>
              <b-form-group v-slot="{ ariaDescribedby }">
                <validation-provider v-slot="{ errors }" rules="required">
                  <b-form-radio-group
                    v-model="item.isProceed"
                    :disabled="isReadOnly || hasInventoryProcess"
                    :id="`radio-group-isProceed-${item.key}`"
                    :name="`radio-options-isProceed-${item.key}`"
                    :options="yesNoOptions"
                    :aria-describedby="ariaDescribedby"
                    @input="onProceedChange"
                  ></b-form-radio-group>
                  <error
                    v-if="errors[0]"
                    variant="no-border"
                    message="El campo es requerido."
                  />
                </validation-provider>
              </b-form-group>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="my-3">
              <div class="color-secondary-6 font-14">
                Clasificación de Servicio:
              </div>
              <validation-provider
                v-slot="{ errors }"
                :rules="!isClasificationDisabled ? 'required' : ''"
              >
                <custom-drop-down
                  fieldkey="id"
                  fieldname="name"
                  placeholder="Seleccione"
                  v-model="item.classification"
                  :options="classifications"
                  :disabled="isClasificationDisabled || isReadOnly"
                  :error="errors[0]"
                  custom-error-msg="La Clasificación de Servicio es requerida"
                />
              </validation-provider>
            </div>
          </div>
        </div>
        <div class="row" v-if="showPurchaseInputs">
          <div class="col-12 col-md-4">
            <div class="pt-2">
              <div class="color-secondary-6 font-14">
                Requiere Compra:
              </div>
              <b-form-group v-slot="{ ariaDescribedby }">
                <validation-provider
                  v-slot="{ errors }"
                  :rules="item.isProceed ? 'required' : ''"
                >
                  <b-form-radio-group
                    v-model="item.isRequiredReplacement"
                    :id="`radio-group-purchase-required-${item.key}`"
                    :name="`radio-options-purchase-required-${item.key}`"
                    :options="yesNoOptions"
                    :disabled="isRequiredReplacementDisabled"
                    :aria-describedby="ariaDescribedby"
                    @input="onRequiredReplacementChange"
                  ></b-form-radio-group>
                  <error
                    v-if="errors[0]"
                    variant="no-border"
                    message="El campo es requerido."
                  />
                </validation-provider>
              </b-form-group>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div>
              <div class="color-secondary-6 font-14">
                Método de Compra:
              </div>
              <div v-if="item.isRequiredReplacement">
                {{ item.purchaseMethod?.name | empty }}
              </div>
              <custom-drop-down
                v-else
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                disabled
                :options="purchaseMethods"
              />
            </div>
          </div>
        </div>
      </div>
      <service-documentation
        v-if="item.record"
        :methods="documentationMethods"
        :data="item.documentation"
        @cancel="onCancelDocumentation"
        @save="onSaveDocumentation"
      ></service-documentation>

      <template #edition>
        <div v-if="showAdditionalInfo" class="bg-light-gray p-3 px-4">
          <div v-if="isSifdePurchaseMethod" class="px-4 py-3 bg-white rounded">
            <div class="d-flex align-items-center mb-3">
              <i class="fas fa-info-circle mr-2 text-orange"></i>
              <div class="color-gray-7 font-16 font-weight-bold">
                Información de Solicitud SIFDE
              </div>
            </div>
            <div class="">
              <div class="row">
                <div class="col-md-3 col-12">
                  <div class="color-secondary-6 font-14 mr-2">
                    Razón:
                  </div>
                  <div class="color-black font-16 ">
                    {{ sifdeRequestInfo?.reasonName | empty }}
                  </div>
                </div>
                <div class="col-md-3 col-12">
                  <div class="color-secondary-6 font-14 mr-2">
                    Fecha de solicitud:
                  </div>
                  <div class="color-black font-16">
                    {{ sifdeRequestInfo?.createdDate | date }}
                  </div>
                </div>
                <div class="col-12 mt-md-3">
                  <div class="color-secondary-6 font-14 mr-2">
                    Comentario:
                  </div>
                  <div class="color-black font-16">
                    {{ sifdeRequestInfo?.comment | empty }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="isInventoryPurchaseMethod" class="bg-light-gray">
            <div class="px-2 py-1">
              <div class="mb-3 font-weight-bold">
                <i class="fas fa-file-user text-orange mr-2"></i>
                Equipo Seleccionado en Inventario
              </div>
            </div>
            <div class="px-2">
              <assigned-equipment-row
                class="custom-row-bg"
                :from-acquisition="true"
                :inventory-flow="true"
                :editable="inventoryEditable"
                :item="item.inventoryEquipment"
                :recommendation="recommendation"
                :referral="item.referral"
                @open="handlerOpen"
                @close="handlerClose"
                @refresh="refreshPage"
              />
            </div>
          </div>
        </div>
      </template>
    </custom-callout>
    <div v-if="!isValid && !isTechnicalAssistanceServiceRequest">
      <div
        class="requistion-row alert alert-danger border-top-0 rounded-bottom"
        role="alert"
      >
        <i class="fas fa-times-circle icon-sand-animate fa-lg mr-3"></i>
        <span class="text-danger">
          Necesita completar la documentación del método de compra.
        </span>
      </div>
    </div>
    <div v-if="hasPendingTransferRequest">
      <div
        class="requistion-row alert alert-danger border-top-0 rounded-bottom"
        role="alert"
      >
        <i class="fas fa-times-circle icon-sand-animate fa-lg mr-3"></i>
        <span class="text-danger">
          El equipo cuenta con una solicitud de transferencia en proceso.
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Error from 'custom-error';
import CustomDropDown from 'custom-drop-down';
import CustomBalloon from 'custom-balloon';
import DropDown from 'dropdown';
import CustomCallout from 'custom-callout';
import ServiceDocumentation from './ServiceDocumentation.vue';
import AssignedEquipmentRow from '@/views/inventory/equipmentMaintenance/inventoryManagement/components/ResultRow';
import referralService from '@/services/api/referralsandequipments.api';

import PurchaseMethods from '@/utils/constants/purchaseMethods';
import PeiAtReferralTypes from '@/utils/constants/peiAtReferralType';
import peiATServiceStatus from '@/utils/constants/peiATServiceStatus';
import ClassificationServiceStatuses from '@/utils/constants/peiAtClassificationServiceStatuses';

const AVAILABILITY_MANAGEMENT = 'AvailabilityManagement';
const TEMPLATE_TAB_INDEX = {
  AdditionalInfo: 0,
};

export default {
  name: 'ReferralServiceInventoryItem',
  components: {
    Error,
    CustomDropDown,
    CustomBalloon,
    DropDown,
    CustomCallout,
    ServiceDocumentation,
    AssignedEquipmentRow,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    inventoryTypes: {
      type: Array,
      required: true,
    },
    classifications: {
      type: Array,
      required: true,
    },
    purchaseMethods: {
      type: Array,
      required: true,
    },
    documentationMethods: {
      type: Array,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    validate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedTemplateTabIndex: TEMPLATE_TAB_INDEX.AdditionalInfo,
      isOpen: false,
      sifdeRequestInfo: null,
    };
  },
  computed: {
    recommendation() {
      return {
        equipmentId: this.item?.inventoryEquipment?.id,
        serviceStatusId: this.item?.referral?.serviceStatusId,
        id: this.item?.equipment?.id,
      };
    },
    inventoryEditable() {
      return (
        this.item.referral?.serviceStatusId ===
        peiATServiceStatus.PendienteDeClasificacion
      );
    },
    isValid() {
      return this.validate
        ? !this.item.isRequiredReplacement || this.hasInventoryProcess
        : true;
    },
    hasPendingTransferRequest() {
      return this.validate
        ? this.item.inventoryEquipment?.hasPendingTransferRequest
        : false;
    },
    yesNoOptions() {
      return [
        {
          value: true,
          text: 'Si',
        },
        {
          value: false,
          text: 'No',
        },
      ];
    },
    showPurchaseInputs() {
      return (
        this.item.referral.referralTypeId ==
        PeiAtReferralTypes.EquipmentRelatedServiceRequest
      );
    },
    isTechnicalAssistanceServiceRequest() {
      return (
        this.item.referral.referralTypeId ==
        PeiAtReferralTypes.TechnicalAssistanceServiceRequest
      );
    },
    isRequiredReplacementDisabled() {
      return (
        this.isReadOnly || !this.item.isProceed || this.hasInventoryProcess
      );
    },
    hasInventoryProcess() {
      return !!this.item.inventoryEquipment || !!this.item.requestedBySifde;
    },
    isClasificationDisabled() {
      return this.isReadOnly || !this.item.isProceed;
    },
    isInventoryPurchaseMethod() {
      return this.item.purchaseMethod?.id === PurchaseMethods.Inventory;
    },
    isSifdePurchaseMethod() {
      return this.item.purchaseMethod?.id === PurchaseMethods.SIFDE;
    },
    showActionItems() {
      return this.actionItems.some((x) =>
        typeof x.visible === 'function' ? x.visible() : x.visible
      );
    },
    showAdditionalInfo() {
      return (
        this.selectedTemplateTabIndex === TEMPLATE_TAB_INDEX.AdditionalInfo
      );
    },

    actionItems() {
      let items = [
        {
          name: 'Ver Inventario',
          icon: 'far fa-file-export text-green',
          click: this.goToInventory,
          visible: this.isInventoryPurchaseMethod,
        },
        {
          name: 'Realizado',
          icon: 'fas fa-calendar-edit text-success',
          click: () => this.onPerformService(),
          visible: () => {
            const isEquipmentRelated =
              this.item.referral.referralTypeId ===
              PeiAtReferralTypes.EquipmentRelatedServiceRequest;

            const isTechnicalAssistance =
              this.item.referral.referralTypeId ===
              PeiAtReferralTypes.TechnicalAssistanceServiceRequest;

            return (
              ((isTechnicalAssistance &&
                Boolean(this.item.status.id) &&
                this.item.status.id !==
                  ClassificationServiceStatuses.ConServicio) ||
                (isEquipmentRelated &&
                  this.item.isProceed &&
                  this.item.isRequiredReplacement === false)) &&
              this.item.status.id ==
                ClassificationServiceStatuses.ConServicioPendiente
            );
          },
        },
        {
          name: 'Ver Documentación',
          icon: 'fas fa-file-alt text-primary',
          visible: () => Boolean(this.item.documentation),
          click: () => this.onPerformService(),
        },
      ];
      if (this.item.inventoryEquipment) {
        items = [
          ...items,
          {
            name: 'Ver Equipo Seleccionado',
            icon: 'far fa-file-user text-green',
            click: () => {
              this.setTab(TEMPLATE_TAB_INDEX.AdditionalInfo);
            },
          },
        ];
      }
      return items;
    },
  },
  methods: {
    async getSifdeRequestInfo() {
      const { data } = await referralService.getSifdeRequestInfo(
        this.item.equipment?.id
      );
      this.sifdeRequestInfo = data;
    },
    onProceedChange(value) {
      this.$emit('proceed', { value, item: this.item });
    },
    onRequiredReplacementChange(value) {
      if (value && !this.item.purchaseMethod) {
        this.item.purchaseMethod = this.purchaseMethods.find(
          (x) => x.id === PurchaseMethods.Inventory
        );
      }
      this.$emit('required-replacement', { value, item: this.item });
    },
    onInventoryChange(value) {
      this.$emit('inventory-type', { value, item: this.item });
    },
    onCancelDocumentation() {
      this.$emit('cancel-documentation', this.item);
    },
    onSaveDocumentation(model) {
      this.$emit('save-documentation', { model, item: this.item });
    },
    onPerformService() {
      this.$emit('perform-service', this.item);
    },
    goToInventory() {
      this.$router.push({
        name: AVAILABILITY_MANAGEMENT,
        params: {
          id: this.item.peiAtServiceId,
          recommendationId: this.item.equipment.id,
        },
      });
    },
    setTab(id) {
      this.selectedTemplateTabIndex = id;
      this.isOpen = true;
    },
    onToggle() {
      if (this.isOpen) {
        this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.AdditionalInfo;
      } else if (this.isSifdePurchaseMethod && !this.sifdeRequestInfo) {
        this.getSifdeRequestInfo();
      }
      this.isOpen = !this.isOpen;
    },
    handlerOpen(item) {
      item.isOpen = true;
    },
    handlerClose(item) {
      item.isOpen = false;
      this.$emit('refresh');
    },
    refreshPage() {
      this.selectedTemplateTabIndex = null;
      this.isOpen = false;
      this.$emit('refresh');
    },
  },
};
</script>

<style scoped lang="scss">
.service-container {
  border-left: 5px solid #d9e5df;
}

::v-deep
  .custom-control-input:disabled:checked
  ~ .custom-control-label::before {
  background-color: #3f5b60 !important;
  border-color: #3f5b60 !important;
}
</style>
